import { default as axios } from '../utils/axios.instances' // eslint-disable-line

const axiosInstance = axios.getSTAxios() // eslint-disable-line

export default {

  async loadElabel (options) {
    return new Promise((resolve, reject) => {
      axiosInstance.get(`/products/${options.id}/elabel/`).then((res) => {
        resolve(res.data)
      }).catch((err) => {
        reject(err)
      })
    })
  },

  async publishElabel (id) {
    return new Promise(function (resolve, reject) {
      axiosInstance.post(`products/${id}/elabel/`, { is_published: true }).then((res) => {
        resolve(res.data)
      }).catch(function (error) {
        reject(error.response)
      })
    })
  },

  async unpublishElabel (id) {
    return new Promise(function (resolve, reject) {
      axiosInstance.post(`products/${id}/elabel/`, { is_published: false }).then((res) => {
        resolve(res.data)
      }).catch(function (error) {
        reject(error.response)
      })
    })
  },

  async updateElabel (options) {
    return new Promise((resolve, reject) => {
      // backend allows 255 chars for sku but only 200 for name, and we use sku for name here, which causes backend error if the sku is over 200 chars
      const name = options.name && options.name.length > 200 ? options.name.slice(0, 200) : options.name

      axiosInstance.post(`products/${options.id}/elabel/`, { name, data: options.data, is_published: options.is_published }).then((res) => {
        resolve(res.data)
      }).catch(function (error) {
        reject(error.response)
      })
    })
  }
}
